<template>
  <v-container fluid :class="bgclass" id="pricing">
    <v-row justify="center">
      <v-col cols="12" align="center">
        <v-btn-toggle v-model="interval" mandatory>
          <v-btn value='month' small>
            Monthly
          </v-btn>
          <v-btn value='year' small>
            Yearly
          </v-btn>
        </v-btn-toggle> <span class="font-italic">VAT excluded</span>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col
        v-for='(product, index) in products["PATROWLHEARS"][this.distribution]'
        :key='index'
        :style='product.is_default?"max-width: 300px; background-color: #f5f5f5; border-radius: 4px;":"max-width: 300px;"'
        align-self="center"
      >
        <v-card
          class="grey lighten-4"
          light
        >
          <v-card-title
            :class='product.is_default?"justify-center card-pricing-recommended py-3 font-weight-bold primary--text":"justify-center card-pricing py-3 font-weight-bold"'>
            {{product.title}}
          </v-card-title>
          <v-card-subtitle justify="center" align="center">
            {{product.subtitle}}
          </v-card-subtitle>
          <v-card-text class="justify-center plan-price">
            <span style="opacity: 0.5; font-size: 14px">
            Starting at
            </span>
            <br/>
            <br/>
            {{product.amount_monthly}} €
            <br/>
            <span style="opacity: 0.5; font-size: 14px">
            monthly per user ({{ product.amount_monthly * 12 }}€ yearly)
            </span>
          </v-card-text>
          <v-card-text>
            <dl>
              <dd v-for='f in product.features' :key='f.name'>
                <v-icon dense v-if='f.text' :color="f.color">{{f.icon}}</v-icon>{{f.text}}<span v-if='f.value' class="font-weight-bold">: {{f.value}}</span>
                <span v-if='f.type'><br/></span>
              </dd>
            </dl>

            <!-- quantity -->
            <v-text-field
              dense
              filled
              single-line
              hide-details
              v-model="product.quantity"
              :min="product.min_quantity"
              type="number"
              append-outer-icon="mdi-plus"
              @click:append-outer="increment(product)"
              prepend-icon="mdi-minus"
              @click:prepend="decrement(product)"
              v-if="product.is_quantity_ajustable == true"
              class="mt-4"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-center pt-1">
            <v-btn
              raised
              color="primary"
              v-if="username == '' || username == null"
              to='/login'
            >Login & Checkout <v-icon>mdi-chevron-right</v-icon></v-btn>
            <v-btn
              raised
              color="primary"
              v-else
              @click="redirToCheckout(index, product.price_id, product.quantity)"
            >Subscribe <v-icon>mdi-chevron-right</v-icon></v-btn>
            <stripe-checkout
              :ref="'checkoutRef-'+index"
              :pk="publishableKey"
              :sessionId="session_id"
              :lineItems="[{price: product.price_id, quantity: product.quantity}]"
              mode="subscription"
              :customerEmail="customer_email"
              :success-url="successUrl"
              :cancel-url="cancelUrl"
              @loading="v => loading = v"
            >
            </stripe-checkout>
          </v-card-actions>
        </v-card>
        <span v-if='product.is_default' class="primary--text pt-2 recommended outlined">Recommended</span>
      </v-col>
      <v-col style="max-width: 300px;" align-self="center">
        <v-card
          class="grey lighten-4"
          light
        >
          <v-card-title
            class="justify-center card-pricing py-3 font-weight-bold">
            Custom/On-premise
          </v-card-title>
          <v-card-subtitle justify="center" align="center">
            For teams having special needs
          </v-card-subtitle>
          <v-card-text class="justify-center plan-price pt-3">
            -
            <br/>
            <span style="opacity: 0.5; font-size: 14px">
            monthly per user
            </span>
          </v-card-text>
          <v-card-text>
            <dl>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Public Feeds<span></span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>PatrowlCERT Private Feeds<span></span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Patrowl Threat Scoring<span></span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Team sharing<span></span></dd>
              <dd><br/></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Offline: <span class="font-weight-bold">Available</span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Monitor assets: <span class="font-weight-bold">Enabled</span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Alerting: <span class="font-weight-bold">Slack, Email, Teams</span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Users: <span class="font-weight-bold">custom</span></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>API requests: <span class="font-weight-bold">custom</span></dd>
              <dd><br/></dd>
              <dd><v-icon dense  color="green">mdi-check</v-icon>Commercial Use<span></span></dd>
            </dl>
          </v-card-text>
          <v-card-actions class="justify-center pt-1">
            <v-btn
              raised
              color="grey"
              href='mailto:sales@patrowl.io?Subject=[PatrowlHears.io] Quotation for plan PatrowlHears'
            >Contact Sales <v-icon>mdi-chevron-right</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

    </v-row>

    <!-- Allah'Snackbar -->
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor" dense>
      {{ snackText }}
      <v-btn text @click="snack = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="loading">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

  </v-container>
</template>

<script>
import Products from '@/common/products';
import { StripeCheckout } from '@vue-stripe/vue-stripe';

export default {
  name: "PricingHears",
  components: {
    StripeCheckout
  },
  mixins: [Products],
  props: [
    'user',
    'bgclass'
  ],
  data: () => ({
    loading: false,
    index: '',
    amount: 1000,
    publishableKey: process.env.VUE_APP_PUBLISHABLE_KEY,
    username: '',
    customer_id: null,
    customer_email: null,
    session_id: '',
    successUrl: process.env.VUE_APP_DOMAIN+"/portal/home",
    cancelUrl: process.env.VUE_APP_DOMAIN+"/portal/home?error=stripe-failed",
    interval: 'year',
    distribution: 'SAAS',
    products_data: {},
    products: {}, // See Products mixin
    snack: false,
    snackColor: '',
    snackText: '',
  }),
  mounted() {
    this.getUsername();
    this.getProducts();
    if (this.user != null) {
      this.customer_id = this.user.customer.id;
      this.customer_email = this.user.email;
    }

    // console.log(this.products)
  },
  watch: {
    interval: {
      handler() {
        // todo: change prices values and IDs
        for (let product in this.products_data) {
          if (this.products['PATROWLHEARS'][this.distribution][product] == null) continue;
          this.products['PATROWLHEARS'][this.distribution][product]['amount_monthly'] = 0;
          this.products['PATROWLHEARS'][this.distribution][product]['quantity'] = this.products_data[product]['min_quantity'];
          this.products['PATROWLHEARS'][this.distribution][product]['min_quantity'] = this.products_data[product]['min_quantity'];
          for (let price in this.products_data[product]['prices']) {
            if (this.products_data[product]['prices'][price]['interval'] == this.interval) {
              this.products['PATROWLHEARS'][this.distribution][product]['amount_monthly'] = this.products_data[product]['prices'][price]['amount_monthly'];
              this.products['PATROWLHEARS'][this.distribution][product]['price_id'] = this.products_data[product]['prices'][price]['id'];
              break;
            }
          }
        }
      },
      deep: true
    },
  },
  methods: {
    increment(self) {
      self.quantity = parseInt(self.quantity, 10) + 1
    },
    decrement(self) {
      if (self.quantity > self.min_quantity){
        self.quantity = parseInt(self.quantity, 10) - 1
      }
    },
    getUsername() {
      this.username = localStorage.getItem('username');
      return this.username;
    },
    getProducts(){
      this.loading = true;
      let products_url = '/api/public/subscriptions/products?product_name=PATROWLHEARS';
      this.$api.get(products_url).then(res => {
        if (res && res.status === 200) {
          this.products_data = res.data.products;

          for (let product in this.products_data) {
            if (this.products['PATROWLHEARS'][this.distribution][product] == null) continue;
            this.products['PATROWLHEARS'][this.distribution][product]['features']['api_ratio']['value'] = this.products_data[product]['api_ratio'];
            this.products['PATROWLHEARS'][this.distribution][product]['amount_monthly'] = 0;
            this.products['PATROWLHEARS'][this.distribution][product]['quantity'] = this.products_data[product]['min_quantity'];
            this.products['PATROWLHEARS'][this.distribution][product]['min_quantity'] = this.products_data[product]['min_quantity'];
            for (let price in this.products_data[product]['prices']) {
              if (this.products_data[product]['prices'][price]['interval'] == this.interval) {
                this.products['PATROWLHEARS'][this.distribution][product]['amount_monthly'] = this.products_data[product]['prices'][price]['amount_monthly'];
                this.products['PATROWLHEARS'][this.distribution][product]['price_id'] = this.products_data[product]['prices'][price]['id'];
                break;
              }
            }
            // console.log(this.products['PATROWLHEARS'][this.distribution][product])
          }
        }
      }).catch(e => {
        console.log(e)
      });
      this.loading = false;
    },
    redirToCheckout(index, price_id, quantity, is_quantity_ajustable=false, min_quantity=1){
      // console.log(this.product)
      // Create a Stripe Checkout session
      this.loading = true;
      let formdata = {
        'price': price_id,
        'quantity': quantity,
        'is_quantity_ajustable': is_quantity_ajustable,
        'min_quantity': min_quantity
      }
      this.$api.post('/api/auth/subscriptions/create-checkout-session', formdata).then(res => {
        // console.log(res.data)
        if (res && res.status === 200 && 'session_id' in res.data) {
          this.session_id = res.data.session_id;
          // Redirect to Stripe Checkout page
          this.$refs['checkoutRef-'+index][0].redirectToCheckout();
        }
      }).catch(e => {
        console.log(e)
      });
      this.loading = false;
    },
  }
};
</script>

<style scoped>
.is-default {
  background-color: primary;
  border: 4px solid primary;
  border-radius: 4px;
}
.recommended {
  text-align: center;
  display: block;
}
.v-card__subtitle {
  min-height: 60px;
}
.card-pricing {
  border-top: solid;
  border-top-width: thick;
  border-color: primary;
}
.card-pricing-recommended {
  border-top: solid;
  border-top-width: thick;
  border-color: #ff7b3f;
}
.plan-price {
  font-size: xxx-large;
}
.starting-from {
  position: absolute;
  left: 45px;
  font-size: 12px;
  line-height: 14px;
  font-family: 'ProximaNova-Regular';
  text-align: right;
}
.col-flex-basis-1 {
  flex-basis: auto;
}
dl.prefered > dd {
  font-weight: 800;
}
</style>
